mtl.alloy.factory['display-image-in-modal'] = (function($) {
    'use strict';

    return function(element, options) {
        $("[data-init='display-image-in-modal']").fancybox();
    }

}($));